
export const STL_SOURCES = [
  { id: 'Uploaded', label: 'Uploaded' },
  { id: '3Shape', label: '3Shape' },
  { id: 'Medit', label: 'Medit' },
  { id: 'Itero', label: 'Itero' },
  { id: 'CsConnect', label: 'CsConnect' },
  { id: 'Opera', label: 'Opera' },
  { id: 'Dexis', label: 'Dexis' },
  { id: 'Dscore', label: 'Dscore' },
  { id: 'Owandy', label: 'Owandy' },
  { id: 'AlliedStar', label: 'AlliedStar' },
  { id: 'Shining', label: 'Shining' },
];